


































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import {Getter} from "vuex-class";

@Component({ components: { SimpleText } })
export default class Label extends Vue {
    @Prop() public insertion!: any;

    @Getter("isDsi") public isDsi!: boolean;

    public excludedCampaign(campaign: string): boolean {
        return true;
    }
}
